module.exports = __webpack_public_path__ + "images/emoji/speaker.ee10b89043a0d9f95fc0.png";